import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  Box,
  Card,
  Stack,
  Container,
  Typography,
  TextField,
  IconButton,
  InputAdornment,
  Snackbar,
  Alert,
  Tabs,
  Tab,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import Page from '../components/Page';
import { api } from 'src/Api';
import { LoadingButton, TabContext, TabPanel } from '@mui/lab';
import Iconify from 'src/components/Iconify';
import { useNavigate } from 'react-router-dom';

import OtpInput from 'react-otp-input';
import { useTheme } from '@emotion/react';

export default function Settings() {
  const theme = useTheme();
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('user'));
  console.log('🚀 ~ Settings ~ userData:', userData);

  const [selectedTab, setSelectedTab] = useState(0);
  const [email, setEmail] = useState(userData?.email);
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOtp] = useState('');
  const [ShowNewEmailInput, setShowNewEmailInput] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [showPassword, setShowPassword] = useState(false);
  const [issubmiting, setissubmiting] = useState(false);
  const [alert, setalert] = useState({ visible: false, message: '' });
  const [deletemodal, setDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [values, setValues] = useState({
    oldpassword: '',
    password: '',
    confirm: ''
  });

  const otpInputStyle = {
    width: '100%',
    height: '56px',
    textAlign: 'center',
    fontSize: '18px',
    borderRadius: '4px',
    boxSizing: 'border-box',
    padding: '6px',
    border: `1px solid ${theme.palette.primary.main} !important`
  };

  const otpContainerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    padding: '20px 20%'
  };

  const resetFunction = () => {
    setissubmiting(true);

    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('oldpassword', values?.oldpassword);
    formdata.append('newpassword', values?.password);
    formdata.append('confirmpassword', values?.confirm);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.changePassword, requestOptions)
      .then(
        (response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            response.json().then((error) => {
              setalert({ visible: true, message: error.message });
            });
          }
        }
        // response.text().then((result_) => ({ status: response.status, body: result_ }))
      )
      .then((result) => {
        // const result = JSON.parse(body);

        if (result.success == true) {
          console.log('result of change password', result);
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setValues({
            oldpassword: '',
            password: '',
            confirm: ''
          });
          navigate('/dashboard/app');
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setissubmiting(false);
      });
  };

  const sendOtpFunction = () => {
    setissubmiting(true);

    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.change_email_otp, requestOptions)
      .then((response) =>
        response.text().then((result_) => ({ status: response.status, body: result_ }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);

        if (status === 201 || status == 200) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setShowOTP(true);
          setOtp('');
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.error);
          setSnackbarSeverity('error');
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setissubmiting(false);
      });
  };

  const handleOTPVerify = () => {
    setissubmiting(true);

    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('email', email);
    formdata.append('otp', otp);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.otp_verify, requestOptions)
      .then((response) =>
        response.text().then((result_) => ({ status: response.status, body: result_ }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);

        if (status === 201 || status == 200) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setShowOTP(false);
          setShowNewEmailInput(true);
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.error);
          setSnackbarSeverity('error');
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setissubmiting(false);
      });
  };

  const handleConfirmNewEMail = () => {
    setissubmiting(true);

    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('email', newEmail);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.changeEmail, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          response.json().then((error) => {
            setalert({ visible: true, message: error.message });
          });
        }
      })
      .then((result) => {
        if (result.success == true) {
          console.log('result of =====>>>>', result);
          // localStorage.setItem('user', JSON.stringify(result.data));
          localStorage.setItem('email', result.data.email);
          localStorage.setItem('user', JSON.stringify(result?.data));

          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          navigate('/dashboard/app');
        } else {
          console.log('else m arah a');
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
        }
      })

      //   .then((response) =>
      //     response.text().then((result_) => ({ status: response.status, body: result_ }))
      //   )
      //   .then(({ status, body }) => {
      //     const result = JSON.parse(body);

      //     if (status === 201 || status == 200) {
      //       setSnackbarOpen(true);
      //       setSnackbarMessage(result.message);
      //       setSnackbarSeverity('success');
      //       setShowNewEmailInput(false);
      //       localStorage.setItem('user', JSON.stringify(result.data));
      //       localStorage.setItem('email', result.data.email);
      //       setEmail(result.data.email);
      //       setNewEmail('');
      //     } else {
      //       setSnackbarOpen(true);
      //       setSnackbarMessage(result.error);
      //       setSnackbarSeverity('error');
      //     }
      //   })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setissubmiting(false);
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue); // Switch the tab based on user selection
    setEmail(userData?.email);
    setShowOTP(false);
  };

  const handleDelete = async () => {
    const token = localStorage.getItem('token');

    try {
      setDeleteLoading(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', `Bearer ${token}`);

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(api.delete_user, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result?.success) {
            // handleLogout();
            setDeleteModal(false);
            localStorage.clear();
            navigate('/login', { replace: true });
            setSnackbarOpen(true);
            setSnackbarMessage(result.message);
            setSnackbarSeverity('success');
          } else {
            setDeleteModal(false);

            // Alert.alert('', result.message);
            setSnackbarOpen(true);
            setSnackbarMessage(result.message);
            setSnackbarSeverity('error');
          }
        })
        .catch((error) => console.error(error))
        .finally(() => {
          setDeleteLoading(false);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleDeleteModal = () => {
    setDeleteModal(false);
  };
  return (
    <Page title={`Settings | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          {/* <IconButton
            style={{
              marginRight: 12,
              height: 40,
              width: 70,
              borderRadius: 5,
              backgroundColor: 'rgba(249, 0, 1,0.1)'
            }}
            onClick={() => navigate(-1)}
          >
            <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#f90001' }} />
          </IconButton> */}
          <Typography variant="h4" sx={{ color: '#f90001' }}>
            Settings
          </Typography>

          <Stack>
            <LoadingButton
              onClick={() => setDeleteModal(true)}
              color="primary"
              variant="contained"
              // loading={loading}
              sx={{ fontSize: 12 }}
            >
              Delete Account
            </LoadingButton>
          </Stack>
        </Stack>
        <Dialog open={deletemodal} onClose={handleDeleteModal}>
          <DialogTitle id="alert-dialog-title">
            {' Are you sure you want to delete your account?'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Deleting your account is irreversible. All your data will be permanently removed.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteModal} color="primary">
              cancel
            </Button>
            <LoadingButton
              sx={{ mr: 2, mb: 1 }}
              loading={deleteLoading}
              variant="contained"
              onClick={handleDelete}
              color="primary"
              autoFocus
            >
              Continue
            </LoadingButton>
          </DialogActions>
        </Dialog>
        <TabContext value={selectedTab.toString()}>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab sx={{ fontSize: '12px' }} label="CHANGE PASSWORD" />
            <Tab sx={{ fontSize: '12px' }} label="CHANGE EMAIL" />
          </Tabs>

          <TabPanel value="0" sx={{ padding: '0px 0px 0px 0px ', marginTop: 2, marginBottom: 2 }}>
            <Card sx={{ p: 3, boxShadow: 2 }}>
              <Box px={0} pb={2}>
                <form>
                  <TextField
                    fullWidth
                    label={'Old Password'}
                    margin="normal"
                    name="oldpassword"
                    onChange={handleChange}
                    type={showPassword ? 'text' : 'password'}
                    value={values.oldpassword}
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleShowPassword} edge="end">
                            <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    className="custom-textfield"
                  />
                  <TextField
                    fullWidth
                    label={'New Password'}
                    margin="normal"
                    name="password"
                    onChange={handleChange}
                    type={showPassword ? 'text' : 'password'}
                    value={values.password}
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleShowPassword} edge="end">
                            <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    className="custom-textfield"
                  />
                  <TextField
                    fullWidth
                    label={'Confirm Password'}
                    margin="normal"
                    name="confirm"
                    onChange={handleChange}
                    type={showPassword ? 'text' : 'password'}
                    value={values.confirm}
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleShowPassword} edge="end">
                            <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    className="custom-textfield"
                  />
                </form>
              </Box>

              <Box display="flex" justifyContent="flex-end" mt={1}>
                <LoadingButton
                  onClick={resetFunction}
                  color="primary"
                  variant="contained"
                  loading={issubmiting}
                  sx={{ fontSize: 12 }}
                >
                  Change Password
                </LoadingButton>
              </Box>
            </Card>
          </TabPanel>

          <TabPanel value="1" sx={{ padding: '0px 0px 0px 0px ', marginTop: 2, marginBottom: 2 }}>
            <Card sx={{ p: 3, boxShadow: 2 }}>
              <Box px={0} pb={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Old Email"
                    // onChange={(e) => setNewEmail(e.target.value)}
                    type="email"
                    value={userData?.email}
                    variant="outlined"
                    className="custom-textfield"
                    disabled
                  />
                </Grid>
                <Grid item xs={12} mt={2}>
                  <TextField
                    fullWidth
                    label="New Email"
                    onChange={(e) => setNewEmail(e.target.value)}
                    type="email"
                    value={newEmail}
                    variant="outlined"
                    className="custom-textfield"
                  />
                </Grid>

                {/* {ShowNewEmailInput ? (
                  <TextField
                    fullWidth
                    label="New Email"
                    onChange={(e) => setNewEmail(e.target.value)}
                    type="email"
                    value={newEmail}
                    variant="outlined"
                    className="custom-textfield"
                  />
                ) : (
                  <TextField
                    disabled={true}
                    fullWidth
                    label="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    value={email}
                    variant="outlined"
                    className="custom-textfield"
                  />
                )} */}
              </Box>

              {showOTP && (
                <div style={otpContainerStyle}>
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderSeparator={<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>}
                    renderInput={(props) => <input {...props} style={otpInputStyle} />}
                  />
                </div>
              )}

              <Box display="flex" justifyContent="flex-end" mt={1}>
                <LoadingButton
                  onClick={handleConfirmNewEMail}
                  color="primary"
                  variant="contained"
                  loading={issubmiting}
                  sx={{ fontSize: 12 }}
                >
                  Save
                </LoadingButton>
                {/* {ShowNewEmailInput ? (
                  <LoadingButton
                    onClick={handleConfirmNewEMail}
                    color="primary"
                    variant="contained"
                    loading={issubmiting}
                    sx={{ fontSize: 12 }}
                  >
                    Save
                  </LoadingButton>
                ) : (
                  <LoadingButton
                    onClick={showOTP ? handleOTPVerify : sendOtpFunction}
                    color="primary"
                    variant="contained"
                    loading={issubmiting}
                    sx={{ fontSize: 12 }}
                  >
                    {showOTP ? 'Verify OTP' : 'Change Email'}
                  </LoadingButton>
                )} */}
              </Box>
            </Card>
          </TabPanel>
        </TabContext>

        <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
